import { isEmpty, kebabCase, map } from 'lodash/fp';

import { CommonQuestions } from '../../types/__codegen__/sanity/graphql';
import { MappedQuestion } from '../../types/question';

const getFormattedQuestionForAccordion = (questions?: CommonQuestions['questions']): MappedQuestion[] => {
  if (isEmpty(questions)) {
    return [];
  }
  return map(
    (item) => ({
      analyticsLabel: item?.question && kebabCase(item?.question),
      body: item?.answerRaw,
      title: item?.question,
    }),
    questions,
  ) as MappedQuestion[];
};
export default getFormattedQuestionForAccordion;
